import {
  CcfAgentFilterIcon,
  CcfBox,
  CcfNoneFoundIcon,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import styles from './ccf-wem-dashboard.module.scss';

/* eslint-disable-next-line */
export interface CcfWemEvaluationsProps {}

/**
 * CcfWemEvaluations - used to display wem evaluations
 * @param props - CcfWemEvaluations
 * @example `<CcfWemEvaluations />`
 */
export function CcfWemEvaluations(props: CcfWemEvaluationsProps) {
  return (
    <CcfBox className={styles.wemScheduleContainer}>
      <CcfBox>
        <CcfTypography className={styles.wemTabTitle}>
          Evaluations
        </CcfTypography>
      </CcfBox>
      <CcfBox className={styles.searchBar}>
        <CcfBox className={styles.searchCountText}>0 evaluations</CcfBox>
        <CcfBox className={styles.filterIconBlock}>
          <CcfAgentFilterIcon style={{ fontSize: 16 }} />
        </CcfBox>
      </CcfBox>
      <CcfBox className={styles.noResultFoundBlock}>
        <CcfNoneFoundIcon style={{ fontSize: 240 }} />
        <CcfTypography className={styles.noResultTxt}>
          We didn't find any results
        </CcfTypography>
      </CcfBox>
    </CcfBox>
  );
}
